import styled from 'styled-components';
import { Colors } from 'enums';

export const DividerStyled = styled.div<{
  margin?: number;
}>`
  width: 100%;
  height: 1px;
  background-color: ${Colors.gray6};

  ${({ margin }) => margin && `margin: ${margin}px 0;`}
`;
